import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import ViewClient from "../view";
import ViewClientTeam from "./view";
import EditClientTeam from "./edit";
import { MODULE_CLIENT } from "variables/constants";

const clientTeamRoutes = [
	generateCRUDRoutes({
		mainTitle: "Client Teams",
		basePath: "clients/:clientId/client-teams",
		mainComponent: <ViewClient />,
	    layout: "/console",	   
	    subTitle:"Client Team",
	    viewComponent: <ViewClientTeam />,
	    createComponent: <EditClientTeam />,
	    editComponent: <EditClientTeam />,
		level:3,
		moduleId: MODULE_CLIENT,   
	})
]

export default clientTeamRoutes;